import React from "react";
import { languages } from "utils/constants";
import Tabs from "components/tabs";

const Nutritions = ({ data, title, lang }) => {
	const { nutritionPer100: hundred, nutritionPerPortion: portion } = data ?? "";

	const rows = ["energy", "fat", "fattyAcids", "carbohydrates", "ofWhichSuggar", "dietaryFiber", "protein", "salt"];

	return (
		<>
			<h2 className="my-4">{title}</h2>
			<table className="text-[#757575] w-full">
				<thead>
					<tr>
						<th className="text-left">
							<strong>{productSingleTranslations[lang]?.typicalValues}</strong>
						</th>
						<th className="text-left">
							<strong>{hundred?.weight}</strong>
						</th>
						<th className="text-left">
							<strong>{portion?.weight}</strong>
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((r, i) =>
						<tr key={i}>
							<td>{Object.hasOwn(productSingleTranslations[lang], r) && productSingleTranslations[lang][r]}</td>
							<td>{Object.hasOwn(hundred ?? {}, r) && hundred[r]}</td>
							<td>{Object.hasOwn(portion ?? {}, r) && portion[r]}</td>
						</tr>
					)}
				</tbody>
			</table>
		</>
	);
};

const NutritionsTab = ({ data }) => {
	const tabs = languages.map(lang => ({
		label: lang,
		content: data.product.details.products.map((p, i) =>
			<Nutritions key={i} data={p.inBundleDetails} title={p?.title} lang={lang} />)
	}));
	return <Tabs tabs={[...tabs]} />;
};

const productSingleTranslations = {
	DE: {
		typicalValues: "durchschnittliche Nährwerte 	",
		energy: "Energiegehalt (kj/kcal)	",
		fat: "Fett (g)	",
		fattyAcids: "davon Gesättigte Fettsäuren (g)	",
		carbohydrates: "Kohlenhydrate (g)	",
		ofWhichSuggar: "davon Zucker (g)	",
		dietaryFiber: "Ballaststoffe (g)	",
		protein: "Eiweiß (g)	",
		salt: "Salz (g)	",
	},
	EN: {
		typicalValues: "Typical values",
		energy: "Energy (kj/kcal)	",
		fat: "Fat (g)	",
		fattyAcids: "of which saturated fatty acids  (g)",
		carbohydrates: "Carbohydrates  (g)",
		ofWhichSuggar: "of which sugar  (g)",
		dietaryFiber: "Dietary fiber  (g)",
		protein: "Protein (g)",
		salt: "Salt (g)",
	},
	FR: {
		typicalValues: "Valeurs nutritionnelles moyennes  ",
		energy: "Énergie (kj/kcal)	",
		fat: "Graisse (g)	",
		fattyAcids: "dont aciddes gras saturés  (g)	",
		carbohydrates: "Glucides  (g)	",
		ofWhichSuggar: "dont sucre  (g)	",
		dietaryFiber: "Fibres alimentaires  (g)	",
		protein: "Protéine (g)	",
		salt: "Sel (g)",
	},
	NL: {
		typicalValues: "Gemiddelde voedingswaarden",
		energy: "Energie (kj/kcal)	",
		fat: "Vet (g)		",
		fattyAcids: "hiervan verzadigde vetzuren  (g)	",
		carbohydrates: "Koolhydraten  (g)	",
		ofWhichSuggar: "van welke suikers  (g)	",
		dietaryFiber: "Vezel  (g)	",
		protein: "Eiwit (g)	",
		salt: "Zout (g)	",
	},
	DK: {
		typicalValues: "Gennemsnitlige Næringsværdier  	",
		energy: "Energi (kj/kcal)	",
		fat: "Fedt (g)	",
		fattyAcids: "heraf mættede fedtsyrer  (g)	",
		carbohydrates: "Kulhydrater  (g)	",
		ofWhichSuggar: "heraf sukker  (g)	",
		dietaryFiber: "Kostfibre  (g)	",
		protein: "Protéine (g)	",
		salt: "Sel (g)	",
	},
};


export default NutritionsTab;
